import { createSlice } from '@reduxjs/toolkit';

const screenCacheSlice = createSlice({
  name: 'screenCache',
  initialState: {}, 
  // shape: { [routeKey]: { viewData: {...}, scrollY: 0 } }
  reducers: {
    cacheScreenState: (state, action) => {
      const { key, viewData, scrollY } = action.payload;
      state[key] = { viewData, scrollY };
    },
    clearScreenCache: (state, action) => {
      delete state[action.payload.key];
    },
  },
});

export const { cacheScreenState, clearScreenCache } = screenCacheSlice.actions;
export default screenCacheSlice.reducer;